import React, { useState } from 'react';

function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    try {
      await fetch('https://formspree.io/f/xkopkdle', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      setSubmitted(true);
      form.reset();
    } catch {
      alert('Error sending message. Please call directly.');
    }
  };

  return (
    <div className="page-container">
      {submitted ? (
        <div className="success-msg">
          <p>Thank you. Your message has been sent.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Your name</label>
            <input type="text" id="name" name="name" required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Your email</label>
            <input type="email" id="email" name="email" required />
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input type="text" id="subject" name="subject" required />
          </div>
          <div className="form-group">
            <label htmlFor="message">Your message (optional)</label>
            <textarea id="message" name="message" rows="5"></textarea>
          </div>
          <button type="submit" className="submit-btn">Submit</button>
        </form>
      )}
      <p className="phone">Phone: <a href="tel:+14154088798">415.408.8798</a></p>
    </div>
  );
}

export default Contact;
